// extracted by mini-css-extract-plugin
export default {"icon-button":"Invites_icon-button__h1Yeg","card-body":"Invites_card-body__3jHYn","fa-lg":"Invites_fa-lg__04JGv","actionBtns":"Invites_actionBtns__izMaC"};